export default {
    app_name: 'ListenBook'
}
